import gql from 'graphql-tag';

export const deleteCoachee = gql`
  mutation DeleteCoacheeV2($userID: String!, $coacheeID: String!) {
    deleteCoacheeV2(userID: $userID, coacheeID: $coacheeID)
  }
`;

export const deleteCoach = gql`
  mutation DeleteCoachV2($userID: String!, $coachID: String!) {
    deleteCoachV2(userID: $userID, coachID: $coachID)
  }
`;

export const addCoach = gql`
  mutation AddCoachV2(
    $userID: String!
    $username: String!
    $ownerName: String!
  ) {
    addCoachV2(userID: $userID, username: $username, ownerName: $ownerName) {
      userName
      userID
      displayName
      alias
      owner
      removable
      relationToUser
      messageCode
    }
  }
`;

export const hideCustomerComment = gql`
  mutation HideCustomerComment(
    $userID: String!
    $contactId: String!
    $responseDateTime: String!
  ) {
    hideCustomerComment(
      userID: $userID
      contactId: $contactId
      responseDateTime: $responseDateTime
    ) {
      success
    }
  }
`;
